import styled from 'styled-components'
import tw from 'twin.macro'
import { UploadImageIcon } from '../../icons/UploadImageIcon'

import { colors } from '../../themes/Colors'

export const AssetCardContainer = styled.div`
  ${tw`flex flex-col items-center p-6 rounded-[8px] border-[1px] border-dashed`};
  border-color: ${colors.coolGrey};
  background: ${(props) =>
    props.isDragActive ? `${colors.opaceBlue}` : 'transparent'};
  border-color: ${(props) =>
    props.isDragActive
      ? `${colors.skyblue}`
      : props.isNotValid
      ? `${colors['light-red-600']}`
      : props.isDisabled
      ? `${colors.slate}`
      : `${colors['light-blue-gray-300']}`};
`
export const TextContainer = styled.div`
  ${tw`text-14px text-center`};
  color: ${(props) =>
    props.isNotValid ? `${colors.lipstick}` : `${colors.coolGrey}`};
`
export const UploadIcon = styled(UploadImageIcon)`
  ${tw`mb-4 w-[48px] h-[48px]`};
`
export const UploadedImage = styled.img`
  ${tw`mr-30px w-[100px] h-[64px]`};
`
export const UploadFileTextOrDragDropContainer = styled.div``

export const TypesOfImagesAndDimensionsText = styled.span`
  ${tw`text-14px text-blue-gray-500 font-inter`};
  color: ${colors.coolGrey};
`
export const FileUploaderLabel = styled.span`
  ${tw`text-14px mb-4`};
  color: ${colors.blueGreyThree};
`
export const DragAndDropText = styled.span`
  ${tw`text-sm ml-1`};
  color: ${colors.battleshipGrey};
`
export const DropZoneContainer = styled.div``

export const UploadFileText = styled.span`
  ${tw`text-sm`};
  color: ${colors.lightDarkBlue};
`
